import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { KycService } from '../kyc.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-kyc-form',
  templateUrl: './kyc.component.html',
  styleUrls: ['./kyc.component.css']
})

export class KycComponent implements OnInit {
  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChild('signatureClose') signatureClose: ElementRef;
  @ViewChild('canvas') canvas: ElementRef;
  public currentStep = 0;
  // Form groups for each step
  public infoForm!: FormGroup;
  public contactsForm!: FormGroup;
  public voiceServicesForm!: FormGroup;
  public messagingServicesForm!: FormGroup;
  public signatureForm!: FormGroup;
  private ctx: CanvasRenderingContext2D;
  private isDrawing: boolean = false;
  private lastX: number = 0;
  private lastY: number = 0;
  public errorMessageDisplayed: boolean = false;
  public urlData: any;
  public nvID: any
  public current_date: any;

  constructor(private route: ActivatedRoute, private fb: FormBuilder, private __service: KycService, private router: Router) {
    this.route.queryParams.subscribe(params => {
      console.log(params['id']);
      this.nvID = params['id']
      this.__service.getFormPatchValue(params['id']).subscribe(res => {
        console.log("new value", res)
        this.matchValue(res)
      })
    });
  }

  ngOnInit(): void {
    this.current_datetime();
    this.initForms();
  }

  initForms() {
    this.infoForm = this.fb.group({
      legalName: ['', Validators.required],
      tradeName: ['', Validators.required],
      businessType: ['', Validators.required],
      taxId: ['', [Validators.required, Validators.minLength(9)]],
      headquartersAddress: ['', Validators.required],
      billingAddress: [''], // optional
      websiteUrl: ['', Validators.required],
      socialMediaUrls: ['', Validators.required]
    });


    // Step 2: Your Contacts
    this.contactsForm = this.fb.group({
      billingContactName: ['', Validators.required],
      billingContactEmail: ['', [Validators.required, Validators.email]],
      billingContactPhone: ['', [Validators.required, Validators.minLength(10)]],

      complianceContactName: ['', Validators.required],
      complianceContactEmail: ['', [Validators.required, Validators.email]],
      complianceContactPhone: ['', [Validators.required, Validators.minLength(10)]],

      operationsContactName: ['', Validators.required],
      operationsContactEmail: ['', [Validators.required, Validators.email]],
      operationsContactPhone: ['', [Validators.required, Validators.minLength(10)]],
    });

    // Step 3: Voice Services
    this.voiceServicesForm = this.fb.group({
      usingVoiceServices: ['', [Validators.required]],
      voiceServicesUsage: [''],
      engageInTelemarketing: [''],
      usePrerecordedMessages: [''],
      preventDNCCalls: [''],
      callWirelessNumbers: [''],
      haveOptInPermission: [''],
      tcpaCompliant: ['']
    });

    // Step 4: Messaging Services
    this.messagingServicesForm = this.fb.group({
      usingMessagingServices: ['', [Validators.required]],
      messagingServicesUsage: [''],
      haveOptInPermissionMsg: [''],
      engageInMarketing: [''],
      marketingActivitiesExplanation: [''],
      ctiaCompliant: ['']
    });

    // Step 5: Signature & Certification
    this.signatureForm = this.fb.group({
      legalVerification: [false],
      signerName: ['', [Validators.required]],
      signerTitle: ['', [Validators.required]],
      kyc_signature: ['', [Validators.required]],
      signDate: [this.current_date]
    });

    // Watch for value changes in form controls that need conditional validation
    this.voiceServicesForm.get('usingVoiceServices').valueChanges.subscribe(value => {
      const voiceUsageControl = this.voiceServicesForm.get('voiceServicesUsage');
      if (value === 'yes') {
        voiceUsageControl.setValidators(Validators.required);
      } else {
        voiceUsageControl.clearValidators();
      }
      voiceUsageControl.updateValueAndValidity();
    });

    this.voiceServicesForm.get('engageInTelemarketing').valueChanges.subscribe(value => {
      const preInControl = this.voiceServicesForm.get('usePrerecordedMessages');
      if (value === 'yes') {
        preInControl.setValidators(Validators.required);
      } else {
        preInControl.clearValidators();
      }
      preInControl.updateValueAndValidity();
    });

    this.voiceServicesForm.get('callWirelessNumbers').valueChanges.subscribe(value => {
      const optControl = this.voiceServicesForm.get('haveOptInPermission');
      if (value === 'yes') {
        optControl.setValidators(Validators.required);
      } else {
        optControl.clearValidators();
      }
      optControl.updateValueAndValidity();
    });

    this.messagingServicesForm.get('usingMessagingServices').valueChanges.subscribe(value => {
      const msgUsageControl = this.messagingServicesForm.get('messagingServicesUsage');
      if (value === 'yes') {
        msgUsageControl.setValidators(Validators.required);
      } else {
        msgUsageControl.clearValidators();
      }
      msgUsageControl.updateValueAndValidity();
    });

    this.messagingServicesForm.get('engageInMarketing').valueChanges.subscribe(value => {
      const marketingExplanationControl = this.messagingServicesForm.get('marketingActivitiesExplanation');
      if (value === 'yes') {
        marketingExplanationControl.setValidators(Validators.required);
      } else {
        marketingExplanationControl.clearValidators();
      }
      marketingExplanationControl.updateValueAndValidity();
    });
  }
  current_datetime() {
    let now = new Date();
    this.current_date = new Date();
    let year = "" + now.getFullYear();
    let month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
    let day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
    let hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
    let minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
    let second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
    return year + '-' + month + "-" + day;

  }
  businessInfo: any
  businessData: any
  matchValue(data: any) {
    console.log("matchValue", data.data);

    // Clear old data if necessary
    this.businessData = {};

    // Create an object to hold form values to patch
    const patchObject: any = {};

    data.data.forEach((item: any) => {
      // Store in businessData (optional)
      this.businessData[item.key] = item.value;

      // Add to patch object
      patchObject[item.key] = item.value;
    });

    console.log('Patch Object:', patchObject);

    // Now patch all at once
    this.infoForm.patchValue(patchObject);
    this.contactsForm.patchValue(patchObject);
    this.voiceServicesForm.patchValue(patchObject);
    this.messagingServicesForm.patchValue(patchObject);
    this.signatureForm.patchValue(patchObject);
  }


  // nextStep() {
  //   this.stepper.next();
  //   this.currentStep++;
  // }

  nextStep(): void {
    if (this.currentStep === 0) {
      // First step: validate infoForm
      if (this.infoForm.invalid) {
        Object.values(this.infoForm.controls).forEach(control => control.markAsTouched());
        return;
      }
    }

    if (this.currentStep === 1) {
      // Second step: validate contactsForm
      if (this.contactsForm.invalid) {
        this.markFormGroupTouched(this.contactsForm);
        return;
      }
    }

    if (this.currentStep === 2) {
      // Second step: validate contactsForm
      if (this.voiceServicesForm.invalid) {
        this.markFormGroupTouched(this.voiceServicesForm);
        return;
      }
    }

    if (this.currentStep === 3) {
      // Second step: validate contactsForm
      if (this.messagingServicesForm.invalid) {
        this.markFormGroupTouched(this.messagingServicesForm);
        return;
      }
    }

    console.log('Step', this.currentStep, 'is valid, moving to next step...');
    this.stepper.next();
    this.currentStep++;
  }


  markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if ((control as FormGroup).controls) {
        this.markFormGroupTouched(control as FormGroup);
      }
    });
  }


  prevStep() {
    this.stepper.previous();
    this.currentStep--;
  }

  preview() {
    console.log("view")
  }

  submit() {
    if (this.isFormValid()) {
      const formData = {
        info: this.infoForm.value,
        contacts: this.contactsForm.value,
        voiceServices: this.voiceServicesForm.value,
        messagingServices: this.messagingServicesForm.value,
        signature: this.signatureForm.value,
        ...(this.nvID > 0 && { id: this.nvID })
      };

      console.log(this.nvID > 0 ? "update form" : "save form", formData);

      const request$ = this.nvID > 0
        ? this.__service.updateKYC(formData)
        : this.__service.submitKyc(formData);

      request$.subscribe((res: any) => {
        console.log(res);
        this.router.navigate(this.nvID > 0 ? ['kyc/kyc-list'] : ['kyc/kyc-list']);
      });

    } else {
      // Mark all forms as touched so error messages show
      this.markFormGroupTouched(this.infoForm);
      this.markFormGroupTouched(this.contactsForm);
      this.markFormGroupTouched(this.voiceServicesForm);
      this.markFormGroupTouched(this.messagingServicesForm);
      this.markFormGroupTouched(this.signatureForm);

      // alert('Please complete all required fields before submitting.');
    }
  }

  isFormValid(): boolean {
    return this.infoForm.valid &&
      this.contactsForm.valid &&
      this.voiceServicesForm.valid &&
      this.messagingServicesForm.valid &&
      this.signatureForm.valid;
  }

  async init() {
    const canvasEl = this.canvas.nativeElement;
    const parent = canvasEl.parentElement;
    const devicePixelRatio = window.devicePixelRatio || 1;
    const width = parent.clientWidth || window.innerWidth;
    // const height = parent?.clientHeight || window.innerHeight;
    canvasEl.width = width * devicePixelRatio;
    // canvasEl.height = height * devicePixelRatio;
    canvasEl.style.width = `${width}px`;
    // canvasEl.style.height = `${height}px`;
    this.ctx = canvasEl.getContext('2d');
    this.ctx.scale(devicePixelRatio, devicePixelRatio);
    this.ctx.strokeStyle = '#222';
    this.ctx.lineCap = 'round';
    this.ctx.lineJoin = 'round';
    this.ctx.lineWidth = 4;
    this.isDrawing = false;

    canvasEl.addEventListener('mousedown', (e) => {
      this.isDrawing = true;
      this.lastX = e.offsetX;
      this.lastY = e.offsetY;
    });

    canvasEl.addEventListener('mousemove', (e) => {
      if (!this.isDrawing) return;
      this.draw(e.offsetX, e.offsetY);
      this.lastX = e.offsetX;
      this.lastY = e.offsetY;
    });

    canvasEl.addEventListener('mouseup', () => this.isDrawing = false);
    canvasEl.addEventListener('mouseleave', () => this.isDrawing = false);

    // Touch Events
    canvasEl.addEventListener('touchstart', (e: TouchEvent) => {
      e.preventDefault();
      this.isDrawing = true;
      const rect = canvasEl.getBoundingClientRect();
      const touch = e.touches[0];
      this.lastX = (touch.clientX - rect.left);
      this.lastY = (touch.clientY - rect.top);
    });

    canvasEl.addEventListener('touchmove', (e: TouchEvent) => {
      if (!this.isDrawing) return;
      e.preventDefault();
      const rect = canvasEl.getBoundingClientRect();
      const touch = e.touches[0];
      const x = (touch.clientX - rect.left);
      const y = (touch.clientY - rect.top);
      this.draw(x, y);
      this.lastX = x;
      this.lastY = y;
    });

    canvasEl.addEventListener('touchend', () => this.isDrawing = false);
    canvasEl.addEventListener('touchcancel', () => this.isDrawing = false);
    const element: HTMLElement = document.getElementById('auto_trigger') as HTMLElement;
    element.click();
  }

  draw(x: number, y: number) {
    this.ctx.beginPath();
    this.ctx.moveTo(this.lastX, this.lastY);
    this.ctx.lineTo(x, y);
    this.ctx.stroke();
  }

  clearCanvas() {
    this.ctx.clearRect(0, 0, this.canvas.nativeElement.width, this.canvas.nativeElement.height);
    this.errorMessageDisplayed = false;
  }

  async saveSignature() {
    if (this.isCanvasEmpty()) {
      this.errorMessageDisplayed = true;
      return;
    }
    const a = document.createElement('a');
    a.href = await this.canvas.nativeElement.toDataURL();
    this.urlData = a.href;
    await this.signatureForm.patchValue({ 'kyc_signature': this.urlData });
    document.getElementById("myModal").click();
  }
  isCanvasEmpty() {
    const canvasData = this.ctx.getImageData(0, 0, this.canvas.nativeElement.width, this.canvas.nativeElement.height).data;
    for (let i = 0; i < canvasData.length; i += 4) {
      if (canvasData[i + 3] !== 0) {
        return false;
      }
    }
    return true;
  }
  showModel() {
    setTimeout(() => {
      this.init();
      this.errorMessageDisplayed = false;
    }, 500);

  }
}
